import { List, ListItem } from 'components/List';
import { Table, TableBody, TableCell, TableHeadCell, TableRow } from 'components/Table';
import { ProjectSectionHeading, ProjectTextRow } from 'layouts/Project';

export function SpecTable({ heading, rows, ...rest }) {
  return (
    <ProjectTextRow stretch width="m" {...rest}>
      <ProjectSectionHeading>{heading}</ProjectSectionHeading>
      <Table>
        <TableBody>
          {rows.map(({ label, value }) => (
            <TableRow key={label}>
              <TableHeadCell>{label}</TableHeadCell>
              <TableCell>
                {Array.isArray(value) ? (
                  <List>
                    {value.map((item, index) => (
                      <ListItem key={index}>{item}</ListItem>
                    ))}
                  </List>
                ) : (
                  value
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </ProjectTextRow>
  );
}
